import { useForm } from "@mantine/form";
import FormInputWrapper from "../formInputWrapper/FormInputWrapper";
import { Box, Button, Group, MultiSelect, RangeSlider } from "@mantine/core";
import { logger } from "utils/logger";

const TalentFilterPanel = ({ onCancel, onApply, filter, filterItems }) => {

    const form = useForm({
        initialValues: {
            ...filter,
        },
    });

    const getFilterVars = (key) => {
        var res = [];
        logger.log(filterItems)
        if (filterItems[key]) Object.keys(filterItems[key]).forEach((val) => res.push(val));
        return res;
    };

    return (
        <Box shadow='xs' style={{ width: '100%' }}>
            <form onSubmit={form.onSubmit((values) => onApply(values))}>
                <FormInputWrapper label='Agency' id='input-agency' labelWidth={'120px'}>
                    <MultiSelect data={getFilterVars('agencies')} label='' placeholder='Pick all that you like' searchable {...form.getInputProps('agency')} />
                </FormInputWrapper>

                <FormInputWrapper label='Status' id='input-status' labelWidth={'120px'}>
                    <MultiSelect clearable data={getFilterVars('statuses')} label='' placeholder='Pick all that you like' searchable {...form.getInputProps('status')} />
                </FormInputWrapper>
                <FormInputWrapper label='Category' id='input-category' labelWidth={'120px'}>
                    <MultiSelect data={getFilterVars('categories')} label='' placeholder='Pick all that you like' searchable {...form.getInputProps('category')} />
                </FormInputWrapper>
                {/* <FormInputWrapper label='Status' id='input-status' labelWidth={'120px'}>
                    <MultiSelect data={getFilterVars('statuses')} label='' placeholder='Pick all that you like' searchable nothingFound='Nothing found' {...form.getInputProps('status')} />
                </FormInputWrapper> */}
                <FormInputWrapper label='Gender' id='input-gender' labelWidth={'120px'}>
                    <MultiSelect data={getFilterVars('genders')} label='' placeholder='Pick all that you like' searchable {...form.getInputProps('gender')} />
                </FormInputWrapper>

                {/* <FormInputWrapper label='Age' id='input-age' labelWidth={'120px'}>
                    <RangeSlider defaultValue={''} marks={marks} {...form.getInputProps('age')} />
                </FormInputWrapper> */}

                <Group justify='space-between' mt='lg'>
                    <Button component='button' variant='subtle' size='sm' onClick={() => onCancel()}>
                        Cancel
                    </Button>
                    <Button type='submit' size='sm'>
                        Apply
                    </Button>
                </Group>
            </form>
        </Box>
    );
};

export default TalentFilterPanel;

const marks = [
    { value: 20, label: '20' },
    { value: 50, label: '50' },
    { value: 80, label: '80' },
];

